import { yupResolver } from "@hookform/resolvers/yup/dist/yup";
import { useForm } from "react-hook-form";
import APIS from "../../constant/EndPoint";
//@ts-ignore
import { FormLayout } from "@careinfo/layout";
import { createRunsheetValidationForm } from "../../utils/validationSchemas";
import ComboboxInput from "../Reusable/ComboboxInput";
import TextField from "../Reusable/TextInput";
//@ts-ignore
import { tw } from "@careinfo/tailwind";
import Modal from "../Reusable/Modal";
import VehicleForm from "./VehicleForm";
import { useEffect, useState } from "react";
import DriverForm from "./DriverForm";
import NumberField from "../Reusable/NumberField";
import { postApiData } from "../../helpers/AxiosInstance";

const CreateVehicleManifest = (props: any) => {
  const {
    handleCreate,
    isLoading,
    handleAddVehicle,
    isVehicleLoading,
    handleAddDriver,
    isDriverLoading,
    openAddDriverPopup,
    setOpenAddDriverPopup,
    openAddVehiclePopup,
    setOpenAddVehiclePopup,
    data,
  } = props;
  const {
    register,
    handleSubmit,
    formState: { errors },
    setError,
    setValue,
    getValues,
    clearErrors,
    watch,
  } = useForm<any>({
    resolver: yupResolver(createRunsheetValidationForm),
    defaultValues: async () => {
      return {
        freight: 0,
        advance: 0,
        balance: 0,
        destination_branch: data?.[0],
      };
    },
  });

  // const [previousCities, setPreviousCities] = useState([]);

  const destinationBranch = watch("destination_branch");
  // const handleGetAllowedCity = async (value: any) => {
  //   const url = `${APIS.VEHICLE_MANIFEST}last-allowed-cities/`;
  //   const formData = {
  //     destination_branch: value?.id ?? value,
  //   };
  //   try {
  //     const res = await postApiData({ url, formData, setError });
  //     if (res?.status === 200) {
  //       setPreviousCities(res?.data?.allowed_cities);
  //       setValue(
  //         "allowed_cities",
  //         res?.data?.allowed_cities?.map((item: any) => ({
  //           label: item?.name,
  //           value: item?.id,
  //         })),
  //       );
  //     }
  //   } catch (err) {
  //     console.error(err);
  //   }
  // };

  // useEffect(() => {
  //   if (destinationBranch) {
  //     handleGetAllowedCity(destinationBranch);
  //   }
  // }, [destinationBranch]);

  useEffect(() => {
    const freight = Number(watch("freight")) || 0;
    const advance = Number(watch("advance")) || 0;
    setValue("balance", freight - advance);
  }, [watch("freight"), watch("advance")]);

  return (
    <>
      <FormLayout
        handleSubmit={handleSubmit}
        handleFormSubmit={handleCreate}
        setError={setError}
        buttonLabel={"Submit"}
        isLoading={isLoading}
      >
        <div className={tw`mx-4`}>
          <div className={tw`grid grid-cols-4 gap-x-4 `}>
            <div className={tw`w-full flex `}>
              <div className={tw`w-full`}>
                <ComboboxInput
                  url={APIS.VEHICLE}
                  queryKey={"vehicle"}
                  register={register("vehicle")}
                  errors={errors?.vehicle}
                  name={"vehicle"}
                  label={"Vehicle Number"}
                  setValue={setValue}
                  placeholder={"Search vehicle"}
                  getValues={getValues}
                  clearErrors={clearErrors}
                />
              </div>
              <button
                className={tw`border px-4  py-2 h-10 relative top-10 focus:outline-none focus-visible:ring-2 focus-visible:ring-primary ring-offset-1`}
                type="button"
                onClick={() => setOpenAddVehiclePopup(!openAddVehiclePopup)}
              >
                +
              </button>
            </div>

            <div className={tw`w-full flex  `}>
              <div className={tw`w-full`}>
                <ComboboxInput
                  url={APIS.DRIVER}
                  queryKey={"driver"}
                  register={register("driver")}
                  errors={errors?.driver}
                  name={"driver"}
                  label={"Driver"}
                  props={{
                    is_active: true,
                  }}
                  setValue={setValue}
                  placeholder={"Search driver"}
                  getValues={getValues}
                  clearErrors={clearErrors}
                />
              </div>
              <button
                className={tw`border px-4  py-2 h-10 relative top-10 focus:outline-none focus-visible:ring-2 focus-visible:ring-primary ring-offset-1`}
                type="button"
                onClick={() => setOpenAddDriverPopup(!openAddDriverPopup)}
              >
                +
              </button>
            </div>
            <ComboboxInput
              url={APIS.BRANCH}
              queryKey={"branch"}
              register={register("destination_branch")}
              errors={errors?.destination_branch}
              name={"destination_branch"}
              label={"Destination"}
              props={{
                is_active: true,
              }}
              setValue={setValue}
              placeholder={"Search branch"}
              getValues={getValues}
              clearErrors={clearErrors}
            />
            {/* <MultipleSelectField
              label={"Allowed Cities"}
              queryKey={"allowed-city"}
              register={register("allowed_cities")}
              watch={watch}
              setValue={setValue}
              url={`${APIS.LOCATION}flat-location/`}
              errors={errors.allowed_cities}
              value={
                Array.isArray(previousCities) && previousCities?.length > 0
                  ? previousCities?.map((item: any) => ({
                      label: item?.name,
                      value: item?.id,
                    }))
                  : []
              }
              props={{
                level: 3,
                is_active: true,
              }}
            /> */}
          </div>
          <div className={tw`grid grid-cols-3 gap-x-4 `}>
            <NumberField
              value={getValues("freight")}
              register={register("freight")}
              errors={errors?.freight}
              label={"Freight"}
              setValue={setValue}
              clearErrors={clearErrors}
            />
            <NumberField
              value={getValues("advance")}
              register={register("advance")}
              errors={errors?.advance}
              label={"Advance"}
              setValue={setValue}
              clearErrors={clearErrors}
            />
            <NumberField
              value={getValues("balance")}
              register={register("balance")}
              errors={errors?.balance}
              label={"Balance"}
              setValue={setValue}
              clearErrors={clearErrors}
            />
          </div>
          <TextField
            label={"Note"}
            register={register(`note`)}
            errors={errors?.note}
          />
        </div>
      </FormLayout>
      <Modal
        isOpen={openAddVehiclePopup}
        setIsOpen={setOpenAddVehiclePopup}
        title={"Add Vehicle"}
        children={
          <>
            <VehicleForm
              register={register}
              errors={errors}
              handleSubmit={handleSubmit}
              handleAddVehicle={handleAddVehicle}
              isVehicleLoading={isVehicleLoading}
            />
          </>
        }
      />
      <Modal
        isOpen={openAddDriverPopup}
        setIsOpen={setOpenAddDriverPopup}
        title={"Add Driver"}
        children={
          <>
            <DriverForm
              register={register}
              errors={errors}
              handleSubmit={handleSubmit}
              setValue={setValue}
              getValues={getValues}
              clearErrors={clearErrors}
              handleAddDriver={handleAddDriver}
              isDriverLoading={isDriverLoading}
            />
          </>
        }
      />
    </>
  );
};

export default CreateVehicleManifest;
